/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/stories-grid.scss';

const propTypes = {
    items: PropTypes.array.isRequired, // eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const StoriesGrid = ({ items, className }) => {
    const reversedItems = items.reverse();
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.table}>
                    {reversedItems.map(story => {
                        return (
                            <div className={styles.card}>
                                <a href={`stories/${story.slug}`}>
                                    <div
                                        className={styles.image}
                                        style={{
                                            backgroundImage: `url('${story.video.thumbnail.url.replace(
                                                /_[0-9]+x[0-9]+/,
                                                '',
                                            )}')`,
                                        }}
                                    />
                                </a>

                                <div className={styles.title}>
                                    <a href={`stories/${story.slug}`}>{story.title} </a>
                                </div>

                                <div
                                    className={styles.description}
                                    dangerouslySetInnerHTML={{ __html: story.description }}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

StoriesGrid.propTypes = propTypes;
StoriesGrid.defaultProps = defaultProps;

export default StoriesGrid;
